import {useEffect,useState} from 'react';
import {CreditCard} from 'lucide-react';
import {api,send} from '../../api';
import {Button} from '../ui/button';
import type {StripeSettingsView} from '../../../../src/application/pay/stripe-settings';
import './signature.css';

/**
 * "Pay now" on the pay link through Stripe Checkout, test mode only (#260). Owner-only. The keys are host secrets set by
 * the founder; this card only shows them masked and turns the button on or off.
 */
export function StripeCheckoutCard({owner}:{owner:boolean}){
 const [view,setView]=useState<StripeSettingsView|null>(null);
 const [error,setError]=useState('');const [saved,setSaved]=useState('');const [saving,setSaving]=useState(false);
 useEffect(()=>{if(!owner)return;void api<StripeSettingsView>('/app-api/settings/stripe').then(setView)
  .catch(()=>setError('The Stripe settings could not be loaded.'));},[owner]);
 if(!owner)return null;
 const save=async(mode:'off'|'test')=>{setSaving(true);setError('');setSaved('');
  try{const v=await send<StripeSettingsView>('/app-api/settings/stripe','PUT',{mode,surchargePercent:0,baseRevision:view?.revision});
   setView(v);setSaved(mode==='test'?'Pay now is on, in Stripe test mode.':'Pay now is off.');}
  catch(e){setError(e instanceof Error?e.message:'The Stripe settings could not be saved.');}finally{setSaving(false);}};
 return <section className="pj-panel sig-card" aria-labelledby="stripe-title">
  <h2 id="stripe-title"><CreditCard size={15} aria-hidden/> Pay now (Stripe, test mode)</h2>
  <p className="sig-lede">Adds a Pay now button to the pay link: card or bank debit through Stripe's hosted page, for the ledger
   total. A confirmed payment stops reminders on those invoices and leaves a task to record it in your books. Test mode only:
   live keys are refused.</p>
  {error&&<div className="alert error" role="alert">{error}</div>}
  {view&&<div className="sig-form">
   <p>Key: <strong>{view.key??'not set'}</strong> · Webhook secret: <strong>{view.webhookSecretSet?'set':'not set'}</strong></p>
   <p className="sig-lede">Webhook endpoint for Stripe: <code>{view.webhookUrl}</code></p>
   {view.problem&&<div className="alert error" role="alert">{view.problem}</div>}
   <p>Status: <strong>{view.ready?'On (test mode)':'Off'}</strong> · Card surcharge: {view.surchargePercent}% (not applied)</p>
   <div className="sig-actions">
    {view.mode==='test'
     ?<Button type="button" variant="outline" disabled={saving} onClick={()=>{void save('off');}}>Turn Pay now off</Button>
     :<Button type="button" disabled={saving||Boolean(view.problem)} onClick={()=>{void save('test');}}>Turn Pay now on (test mode)</Button>}
    {saved&&<span role="status">{saved}</span>}</div>
  </div>}
 </section>;
}
